// extracted by mini-css-extract-plugin
export default {"container":"DialogWlistTime_container__ytgWl","time":"DialogWlistTime_time__UeKOI"};